import React from 'react'
import { Button, Col, Form, Input, message, Row } from 'antd'
import { useApolloClient, useMutation } from '@apollo/client'
import { UPDATE_CATEGORY } from '../../ProductQueries'
import { Category } from '../CategoriesList'
import { requiredRule } from './rules'
import { useSlerp } from '@slerp/client'
import errorReducer from 'errors/errorReducer'

interface EditCategoryFormProps {
  category: Category
  cancelHandler?: () => void
}

const { useForm } = Form

const EditCategoryForm = ({
  category,
  cancelHandler
}: EditCategoryFormProps) => {
  const client = useApolloClient()
  const { user } = useSlerp()
  const [form] = useForm()
  const initialValues = {
    name: category?.name || ''
  }

  const [updateCategory] = useMutation(UPDATE_CATEGORY, {
    fetchPolicy: 'no-cache'
  })

  const onFinish = (values: { name: string }) => {
    const { name } = values

    form.validateFields().then(() => {
      message.destroy()
      message.loading('Updating category', 1)
      updateCategory({
        variables: {
          id: category.id,
          merchantSlug: user.merchant.slug,
          name
        }
      })
        .then((result) => {
          message.destroy()
          message.success('Category updated!', 3)
          client.resetStore()
        })
        .catch((error: Error) => {
          throw errorReducer({
            origin: 'Category',
            data: {
              error: error,
              message: error.message
            }
          })
        })
        .catch((error: Error) => {
          message.destroy()
          message.error(error.message, 3)
        })
    })
  }

  return (
    <Form
      form={form}
      onFinish={onFinish}
      initialValues={initialValues}
      data-testid='category-form'
    >
      <Row className='-category-row'>
        <Col>Name</Col>
      </Row>
      <Row className='-category-row'>
        <Col span={12}>
          <Form.Item name='name' rules={requiredRule}>
            <Input
              required
              placeholder='Name'
              data-testid='category-form-name'
            />
          </Form.Item>
        </Col>
      </Row>

      <Row className='-category-edit'>
        <Col span={12}>
          <Row className='-category-edit'>
            <Col>
              <Button
                onClick={() => cancelHandler && cancelHandler()}
                data-testid='category-form-discard-btn'
              >
                Discard
              </Button>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row justify='end' className='-category-edit'>
            <Col>
              <Button
                type='primary'
                htmlType='submit'
                data-testid='category-form-save-btn'
              >
                Save
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  )
}

export default EditCategoryForm
